import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/hot', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'navbar-solid border-b border-background-200/70'
          : 'navbar-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-play-circle-fill text-xl text-background-50"></i>
            </div>
            <span className={`text-lg font-bold whitespace-nowrap font-heading tracking-wide ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}>
              蜜桃传媒
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : scrolled || !isHome
                      ? 'text-foreground-700'
                      : 'text-background-50/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/hot"
              className="px-5 py-2 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 cursor-pointer transition-all duration-200 hover:bg-primary-600 active:scale-95"
            >
              立即观看
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 px-3 rounded-lg whitespace-nowrap transition-colors ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/hot"
              className="mt-1 px-5 py-2.5 text-sm font-medium text-center whitespace-nowrap rounded-full bg-primary-500 text-background-50 cursor-pointer transition-all duration-200 hover:bg-primary-600"
            >
              立即观看
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}